import React, { useEffect, Fragment } from 'react';
import { useSelector } from 'react-redux';
import ReactGa from 'react-ga';
import Spinner from '../../components/spinner/spinner';
import ErrorHandling from '../error-handling/error-handling';
import InternetConnectivity from '../internet-connectivity/internet-connectivity';
import Modal from '../modal/modal';
import css from './mle.scss';
import DetectDevtools from '../devtools-detect/devtools-detect';
import DevToolsMessage from '../devtools-detect/devtools-message';
import { useAssignUpf } from './mle-hooks';
import { FooterQtc } from '../footer-qtc/footer-qtc';
import { PageTitle } from '../page-title/page-title';
import HeaderAndActivity from './header-and-activity';

const Mle = () => {
  const spinnerReducer = useSelector(state => state.spinnerReducer);
  const { isDevToolsOpen } = useSelector(state => state.detectDevToolsReducer);

  useAssignUpf();

  useEffect(() => {
    ReactGa.initialize(window._env_.gtmId);
    ReactGa.event({
      category: 'UPF init',
      action: 'UPF init',
      nonInteraction: true
    });
  }, []);

  return (
    <Fragment>
      <PageTitle />
      <DetectDevtools />
      <ErrorHandling />
      <Modal />
      <InternetConnectivity />
      {isDevToolsOpen ?
        <DevToolsMessage /> :
        <div className={css.mle}>
          <HeaderAndActivity />
          <FooterQtc />
          <Spinner show={spinnerReducer.length > 0 || false} />
        </div>
      }
    </Fragment>
  );
};

export default Mle;
